import {AxiosCall, CancelTokenSource} from '../axios';

// import { serializeQueryParams } from './PaymentHistoryService';
export const fetchInsuranceCoverages = async (
  clinic_group_id: number | string,
  clinic_id: number | string,
  appointment_id: number | string
  // options: any
): Promise<any> => {
  // const queryParams = serializeQueryParams(options);
  return AxiosCall.get(
    `/clinic-group/${clinic_group_id}/clinic/${clinic_id}/insurance-verification/appointment/${appointment_id}/coverages`
  );
};

export const verifyEligibility = async (
  clinicGroupId: string | number,
  clinicId: string | number,
  appointmentId: string | number,
  data: {
    patient_id: number | string;
    insurance_name?: string;
    member_id?: string;
    group_number?: string;
    bin_number?: string;
    process_control_number?: string;
    rx_group_no?: string;
    insurance_id?: number | string;
    is_refresh?: boolean;
  }
): Promise<any> => {
  return AxiosCall.post(
    `/clinic-group/${clinicGroupId}/clinic/${clinicId}/insurance-verification/appointment/${appointmentId}/verify-eligibility`,
    data
  );
};

export const manuallyVerify = async (
  clinicGroupId: string | number,
  clinicId: string | number,
  appointmentId: string | number,
  data: {
    insurance_name: string;
    subscriber_member_id: string;
    subscriber_group_number: string;
    plan_name: string;
    plan_start_date: string;
    plan_end_date: string;
    policy_number: string;
    plan_number: string;
  }
): Promise<any> => {
  return AxiosCall.post(
    `/clinic-group/${clinicGroupId}/clinic/${clinicId}/insurance-verification/appointment/${appointmentId}/add-insurance-information`,
    data
  );
};

export const getInsuranceVerificationLogs = async ({
  params: {clinicGroupId, clinicId, appointmentId}
}: {
  params: {
    clinicGroupId: number;
    clinicId: number;
    appointmentId: number;
  };
}): Promise<any> => {
  return AxiosCall.get(
    `/clinic-group/${clinicGroupId}/clinic/${clinicId}/insurance-verification/appointment/${appointmentId}/logs`
  );
};

export const getVerificationLogDetails = async ({
  clinicGroupId,
  clinicId,
  appointmentId,
  logId
}: {
  clinicGroupId: number;
  clinicId: number;
  appointmentId: number;
  logId: number;
}): Promise<any> => {
  return AxiosCall.get(
    `/clinic-group/${clinicGroupId}/clinic/${clinicId}/insurance-verification/appointment/${appointmentId}/logs/${logId}/details`
  );
};

export const allPayersListOfGroup = async (
  group_id: number | string,
  search_text = ''
): Promise<any> => {
  return AxiosCall.get(
    `/clinic-group/${group_id}/insurance-verification/payers/all?search_text=${encodeURIComponent(
      search_text
    )}`
  );
};

export const getPayerDetails = async ({
  clinicGroupId,
  payerId
}: {
  clinicGroupId: number;
  payerId: number;
}): Promise<any> => {
  return AxiosCall.get(
    `/clinic-group/${clinicGroupId}/insurance-verification/payer/${payerId}`
  );
};

export const getPatientAllInsuranceDetails = async (
  clinic_group_id: number,
  patient_id: number,
  cancelToken?: CancelTokenSource
): Promise<any> => {
  return AxiosCall.get(
    `clinic-group/${clinic_group_id}/patient/${patient_id}/insurances/all`,
    cancelToken
  );
};

export interface CreatePatientInsurancePayload {
  payer_name: string;
  subscriber_group_no?: string;
  subscriber_member_no: string;
  type?: string;
  bin_number?: string;
  process_control_number?: string;
  rx_group_no?: string;
}

export const createPatientInsurance = async (
  clinicGroupId: string | number,
  patientId: string | number,
  data: CreatePatientInsurancePayload
): Promise<any> => {
  return AxiosCall.post(
    `clinic-group/${clinicGroupId}/patient/${patientId}/insurance`,
    data
  );
};

export interface UpdatePatientInsurancePayload {
  payer_name?: string;
  subscriber_group_no?: string;
  subscriber_member_no?: string;
  type?: string;
  bin_number?: string;
  process_control_number?: string;
  rx_group_no?: string;
  priority?: string;
}

export const updatePatientInsurance = async (
  clinicGroupId: string | number,
  patientId: string | number,
  insuranceId: string | number,
  data: UpdatePatientInsurancePayload
): Promise<any> => {
  return AxiosCall.put(
    `clinic-group/${clinicGroupId}/patient/${patientId}/insurance/${insuranceId}`,
    data
  );
};
